import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

// get faclity List
export const getFaciltyData = (facilityUrl) => (dispatch) => {
  // console.log('getFacilityData page')
  let payLoad = {...facilityUrl, 'device_type': 'web'}
  dispatch({ type: CONSTANTS.GET_FACILITY_RATE_REQUEST })
  dispatch(addEventLog(payLoad, CONSTANTS.GET_FACILITY_RATE_REQUEST))
  let fetchRateUrl = APICONFIG.getFaclityUrl
  // if(fetchByRate){
  //   fetchRateUrl = APICONFIG.getFaclityRateUrl
  // }else{
  //   fetchRateUrl = APICONFIG.getFaclityUrl
  // }
  return postRequest(fetchRateUrl, payLoad).then((res) => {
    let resObject = { ...payLoad, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.GET_FACILITY_RATE_SUCCESS))
    dispatch({ type: CONSTANTS.GET_FACILITY_RATE_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payLoad, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.GET_FACILITY_RATE_FAILURE))
    dispatch({ type: CONSTANTS.GET_FACILITY_RATE_FAILURE })
    return err
  })
}

export const postCardPaymentDetails = (data) => (dispatch) => {
  let payload = {...data, 'device_type': 'web'}
  dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_REQUEST })
  dispatch(addEventLog(payload, CONSTANTS.POST_CARD_PAYMENT_REQUEST))
  return postRequest(APICONFIG.postUrlForPayment, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.POST_CARD_PAYMENT_SUCCESS))
    dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.POST_CARD_PAYMENT_FAILURE))
    dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_FAILURE })
    return err
  })
}

// End Current Parking
export const endParking = (ticket_number) => (dispatch) => {
  dispatch(addEventLog(ticket_number, CONSTANTS.END_PARKING_REQUEST))
  dispatch({ type: CONSTANTS.END_PARKING_REQUEST })
  let tobject = { ticket_number: ticket_number }
  return getRequest(`${APICONFIG.endParking}/${ticket_number}`).then((res) => {
    let resObject = { ...tobject, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.END_PARKING_SUCCESS))
    dispatch({ type: CONSTANTS.END_PARKING_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...tobject, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.END_PARKING_FAILURE))
    dispatch({ type: CONSTANTS.END_PARKING_FAILURE })
    return err
  })
}

// faclity-om-marker 
export const faciltyOnMarker = (facilityData) => (dispatch) => {
  dispatch({ type: CONSTANTS.FACILITY_ON_MARKER_REQUEST })
  dispatch(addEventLog(facilityData, CONSTANTS.FACILITY_ON_MARKER_REQUEST))
  const url = `${APICONFIG.faclityOnMarker}/${facilityData?.facility_id}?arrival_time=${facilityData?.arrival_time}&length_of_stay=${facilityData?.length_of_stay}&use_bonus=${0}&user_id=${facilityData?.user_id}`
  return getRequest(url).then((res) => {
    let resObject = { ...facilityData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.FACILITY_ON_MARKER_SUCCESS))
    dispatch({ type: CONSTANTS.FACILITY_ON_MARKER_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...facilityData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.FACILITY_ON_MARKER_FAILURE))
    dispatch({ type: CONSTANTS.FACILITY_ON_MARKER_FAILURE })
    return err
  })
}
// 

// faclity-om-marker 
export const fetchRateBands = (payload) => (dispatch) => {
  let payLoadRate = {...payload, 'device_type': 'web'}
  dispatch({ type: CONSTANTS.GET_RATE_BANDS_REQUEST })
  dispatch(addEventLog(payLoadRate, CONSTANTS.GET_RATE_BANDS_REQUEST))
  return postRequest(APICONFIG.getRateBands, payLoadRate).then((res) => {
    let resObject = { ...payLoadRate, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.GET_RATE_BANDS_SUCCESS))
    dispatch({ type: CONSTANTS.GET_RATE_BANDS_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payLoadRate, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.GET_RATE_BANDS_FAILURE))
    dispatch({ type: CONSTANTS.GET_RATE_BANDS_FAILURE })
    return err
  })
}


export const applyReservationId = (ticket) => (dispatch) => {
  let payload = {...ticket, 'device_type': 'web'}
  dispatch(addEventLog(payload, CONSTANTS.RESERVATION_ID_REQUEST))
  dispatch({ type: CONSTANTS.RESERVATION_ID_REQUEST })
  return postRequest(APICONFIG.applyReservationID, payload).then((res) => {
      let resObject = { ...payload, ...res }
      dispatch(addEventLog(resObject, CONSTANTS.RESERVATION_ID_SUCCESS))
      dispatch({ type: CONSTANTS.RESERVATION_ID_SUCCESS, data: res })
      return res
  }).catch((err) => {
      let errObject = { ...payload, ...err }
      dispatch(addEventLog(errObject, CONSTANTS.RESERVATION_ID_FAILED))
      dispatch({ type: CONSTANTS.RESERVATION_ID_FAILED })
      return err
  })
}

// Fetch Rate Details Actions
export const fetchRateDetailData = (facilityID) => (dispatch) => {
  dispatch(addEventLog(facilityID, CONSTANTS.FETCH_RATE_DETAILS_REQUEST))
  dispatch({ type: CONSTANTS.FETCH_RATE_DETAILS_REQUEST })
  return getRequest(APICONFIG.getFetchRates+facilityID).then((res) => {
      dispatch(addEventLog(facilityID, CONSTANTS.FETCH_RATE_DETAILS_SUCCESS))
      dispatch({ type: CONSTANTS.FETCH_RATE_DETAILS_SUCCESS, data: res })
      return res
  }).catch((err) => {
      dispatch(addEventLog(facilityID, CONSTANTS.FETCH_RATE_DETAILS_FAILED))
      dispatch({ type: CONSTANTS.FETCH_RATE_DETAILS_FAILED })
      return err
  })
}
// 


export const postWarningCardPaymentDetails = (data) => (dispatch) => {
  let payload = {...data, 'device_type': 'web'}
  dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_REQUEST })
  dispatch(addEventLog(payload, CONSTANTS.POST_CARD_PAYMENT_REQUEST))
  return postRequest(APICONFIG.postWarningUrlForPayment, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.POST_CARD_PAYMENT_SUCCESS))
    dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.POST_CARD_PAYMENT_FAILURE))
    dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_FAILURE })
    return err
  })
}